exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoped-visible-container[data-v-c8a75816]{height:98%;overflow:auto;margin:1% 0;padding:15px}.scoped-contains-email-validation[data-v-c8a75816]{min-height:40vh}", ""]);

// exports
